export default __webpack_public_path__ + "static/media/Connector_Type1Combo.5d239490.svg";